import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/material";
import { ReactNode } from "react";
import TextButton from "@/components/common/buttons/textButton";
import { ClientByTokenQuery } from "@/graphql/queries/clientByToken.graphql.types";

export type Appointment =
  ClientByTokenQuery["clientAccessTokenByPk"]["client"]["visits"][number]["appointment"];

type Props = {
  appointment: Appointment;
  isUpdating: boolean;
  updateAction: (appointmentAccessToken: string) => void;
  icon: ReactNode;
  label: string;
  buttonText: string;
};

export default function AppointmentUpdateStatusRow({
  appointment,
  isUpdating,
  updateAction,
  icon,
  label,
  buttonText,
}: Props) {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        py: 0.5,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Box>{icon}</Box>
        <Typography
          variant="paragraphSmall"
          sx={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </Typography>
      </Stack>
      <TextButton
        onClick={() => updateAction(appointment.accessToken)}
        disabled={isUpdating}
        sx={{ minWidth: "fit-content" }}
      >
        {buttonText}
      </TextButton>
    </Stack>
  );
}
